import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface getClarificationDataTableStructureProps {
  rowActionsFn: (target: any) => DataTableRowActions;
  isValidator?: boolean;
  isRedacteur?: boolean;
}

export const getClarificationDataTableStructure = ({
  rowActionsFn,
  isRedacteur = false,
}: getClarificationDataTableStructureProps): DynamicDataTable => {
  // For redacteurs (grouped view), show DAC group info
  const dacKeyColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.table.dac_reference',
    accessorKey: 'dacReference',
    variant: DataTableColumnVariant.TEXT,
  };

  const questionCountColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.table.question_count',
    accessorKey: 'questionCount',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      return { value: `${value} question(s)` };
    },
  };

  const columns = [dacKeyColumn, questionCountColumn];

  return {
    singular: 'clarification.singular',
    plural: 'clarification.plural',
    columns,
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    rowActionsFn,
    searchableFields: ['dacReference'],
  };
};
